import { Component, ElementRef, NgZone } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { InfoSpedizioniVini } from '../../_classi/InfoSpedizioniVini';
import { VinoItem } from '../../_classi/VinoItem';
import { CantinaService } from '../../_servizi/cantina.service';
import { CarrelloViniService } from '../../_servizi/carrelloVini.service';
import { MessageServiceService } from '../../_servizi/message-service.service';
import { v4 as uuidv4 } from 'uuid';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { StripeService } from 'src/app/_servizi/stripe.service';
@Component({
  selector: 'app-vini-vendibili',
  templateUrl: './vini-vendibili.component.html',
  styleUrls: ['./vini-vendibili.component.css']
})
export class ViniVendibiliComponent {

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  abilitatoVenditaVino = false;
  nonabilitatoMsg = '';

  codiceForm: any;
  linguaCorrente: string;
  layout: number;
  cart: any;

  vini: any[] = [];
  viniFiltered: any[] = [];
  pacchetti: any[] = [];
  pacchettiFiltered: any[] = [];

  loading = false;

  isFiltrati = true;

  constructor(
    private messageService: MessageServiceService,
    private host: ElementRef,
    private zone: NgZone,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private adapter: DateAdapter<any>,
    private carrelloService: CarrelloViniService,
    private router: Router,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService,
    private stripeService: StripeService
  ) { }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params) => {
      this.codiceForm = params.get('cantina');
      this.linguaCorrente = params.get('lingua');
      this.cart = params.get('cart');
      this.layout = parseInt(params.get('layout'));

      this.translate.use(this.linguaCorrente);
      this.adapter.setLocale(this.translate.currentLang);

      this.controllaCantina(this.codiceForm);

      const infoLayout = {
        codiceForm: this.codiceForm,
        layout: this.layout,
        lingua: this.linguaCorrente,
        cart: this.cart
      }
      this.carrelloService.setInfoLayoutVini(infoLayout);

      let idCookie = params.get('idCookie');
      if (idCookie && idCookie !== 'null') {
        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }

    });

    this.observer = new ResizeObserver(entries => {
      this.zone.run(() => {
        this.messageService.sendHeighMessageVini(entries[0].contentRect.height);
      });
    });

    this.observer.observe(this.host.nativeElement);

  }
  ngOnDestroy(): void {
    this.observer.unobserve(this.host.nativeElement);
  }

  controllaCantina(codiceForm): void {
    this.loading = true;
    this.cantinaService.getStato(codiceForm)
      .subscribe(result => {
        this.checkAbilitato = true;
        if (result && result.length > 0) {
          const cantina = result[0];
          if (
            (cantina['wineclub_azione'] === '1' && cantina['wineclub_prova'] === '0') ||
            (cantina['wineclub_azione'] === '1' && cantina['wineclub_prova'] === '1' && moment(cantina['wineclub_scadenza']).isAfter(moment(), 'day'))
          ) {
            this.abilitatoVenditaVino = true;
          }
          const clientUrl = document.referrer;
          this.abilitato = true

          this.appoggioService.setCodiceForm(codiceForm);

          if (cantina['infoStripe'] != null) {
            const infoStripe = {
              abilitatoAccount: cantina['infoStripe']['abilitatoAccountStripe'] === '1' ? true : false,
              abilitatoProduzione: cantina['infoStripe']['abilitatoProduzione'] === '1' ? true : false,
              api_key: cantina['infoStripe']['abilitatoProduzione'] === '1' ? cantina['infoStripe']['apiKeyStripeProduzione'] : cantina['infoStripe']['apiKeyStripeTest'],
              endpoint_secret: cantina['infoStripe']['abilitatoProduzione'] === '1' ? cantina['infoStripe']['endpointSecretProduzione'] : cantina['infoStripe']['endpointSecretTest']
            }
            this.stripeService.setInfoStripe(infoStripe);
          } else {
            this.stripeService.setInfoStripe(null);
          }

          this.appoggioService.setColoriIframe(cantina);

          this.cantinaService.getVini(codiceForm, this.linguaCorrente)
            .subscribe(result => {
              const info = new InfoSpedizioniVini(result['infoSpedizioniSconti']);
              this.cantinaService.setInfoSpedizioniSconti(info);
              this.vini = result['vini'].map(vino => new VinoItem(vino));
              this.viniFiltered = this.vini;

              this.cantinaService.getPacchetti(codiceForm, this.linguaCorrente)
                .subscribe(result2 => {
                  this.pacchetti = result2['pacchetti'].map(pacchetto => new PacchettoItem(pacchetto));
                  this.pacchettiFiltered = this.pacchetti;
                });
            });

        } else {
          this.abilitato = false;
          this.abilitatoVenditaVino = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
        setTimeout(() => {
          this.loading = false;
        }, 2000)
      });
  }

  filtraPacchetti(filtro) {
    if (filtro !== '6' && filtro !== '0') {
      this.pacchettiFiltered = [];
      this.isFiltrati == false;
    } else {
      this.pacchettiFiltered = this.pacchetti;

      switch (filtro) {
        case '6':
          this.isFiltrati = false;
          break;
        case '0':
          this.isFiltrati = true;
          break;
        default:
          this.isFiltrati = false;
          break;
      }

    }
  }

  selezionaVino(event) {
    this.pacchettiFiltered = event ? [] : this.pacchetti;
  }

  selezionaPacchetto(event) {
    this.viniFiltered = event ? [] : this.vini;
  }


}
